var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Automata-LINQ-bench-icon@2x-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4H11.5C11.2239 4 11 4.22386 11 4.5V37C11 37.2761 11.2239 37.5 11.5 37.5H15.5C15.7761 37.5 16 37.2761 16 37V4.5C16 4.22386 15.7761 4 15.5 4ZM12 36.5V5H15V36.5H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6562 24C10.6562 23.7239 10.4324 23.5 10.1562 23.5H6C5.72385 23.5 5.5 23.7239 5.5 24V43.5C5.5 43.7761 5.72385 44 6 44H6.5C6.77615 44 7 43.7761 7 43.5V40C7 39.7239 7.22385 39.5 7.5 39.5H23.5V43.5C23.5 43.7761 23.7239 44 24 44C24.2761 44 24.5 43.7761 24.5 43.5V39.5H41C41.2761 39.5 41.5 39.7239 41.5 40V43.5C41.5 43.7761 41.7239 44 42 44H42.5C42.7761 44 43 43.7761 43 43.5V24C43 23.7239 42.7761 23.5 42.5 23.5H16.7812C16.5051 23.5 16.2812 23.7239 16.2812 24V24.5C16.2812 24.7761 16.5051 25 16.7812 25H23.5V27.5H16.7812C16.5051 27.5 16.2812 27.7239 16.2812 28C16.2812 28.2761 16.5051 28.5 16.7812 28.5H23.5V34H17C16.7239 34 16.5 34.2239 16.5 34.5C16.5 34.7761 16.7239 35 17 35H23.5V36H17C16.7239 36 16.5 36.2239 16.5 36.5C16.5 36.7761 16.7239 37 17 37H23.5V38H7V35H10C10.2761 35 10.5 34.7761 10.5 34.5C10.5 34.2239 10.2761 34 10 34H7V28.5H10.1562C10.4324 28.5 10.6562 28.2761 10.6562 28C10.6562 27.7239 10.4324 27.5 10.1562 27.5H7.5C7.22385 27.5 7 27.2761 7 27V25.5C7 25.2239 7.20985 25 7.46875 25H10.1562C10.4324 25 10.6562 24.7761 10.6562 24.5V24ZM41.5 28.5H24.5V34H41.5V28.5ZM41.5 35H24.5V36H40C40.2761 36 40.5 36.2239 40.5 36.5C40.5 36.7761 40.2761 37 40 37H24.5V38H41.5V35ZM41 27.5H24.5V25H41.0312C41.2901 25 41.5 25.2239 41.5 25.5V27C41.5 27.2761 41.2761 27.5 41 27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 36.5C10.5 36.2239 10.2761 36 10 36H8.5C8.22385 36 8 36.2239 8 36.5C8 36.7761 8.22385 37 8.5 37H10C10.2761 37 10.5 36.7761 10.5 36.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9.5H21C21.2761 9.5 21.5 9.72386 21.5 10V11.5C21.5 11.7761 21.2761 12 21 12H17C16.7239 12 16.5 11.7761 16.5 11.5V10C16.5 9.72386 16.7239 9.5 17 9.5ZM17.5 10.5V11H20.5V10.5H17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 15.5H21C20.7239 15.5 20.5 15.7239 20.5 16H19.5C18.9477 16 18.5 16.4477 18.5 17V17.75H19.5V17H20.5V17.5C20.5 17.7761 20.7239 18 21 18H24.5C24.7761 18 25 17.7761 25 17.5V17H26.25V17.75H27.25V17C27.25 16.4477 26.8023 16 26.25 16H25C25 15.7239 24.7761 15.5 24.5 15.5ZM21.5 17V16.5H24V17H21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12.5H24C24.2761 12.5 24.5 12.7239 24.5 13V14.5C24.5 14.7761 24.2761 15 24 15H18C17.7239 15 17.5 14.7761 17.5 14.5V13C17.5 12.7239 17.7239 12.5 18 12.5ZM18.5 13.5V14H23.5V13.5H18.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchIcon);
export default __webpack_public_path__ + "static/media/bench-icon.9246dabaf541965fa1c725276c128a9d.svg";
export { ForwardRef as ReactComponent };